import React, { useEffect, useState } from "react";
import { CCard, CCardBody, CCardHeader, CCol, CRow } from "@coreui/react";

import CustomWidgetProgress from "./CustomWidgetProgress";
import { apiCallSPGet } from "src/_apiConfig/apiCall";
import Auth from "src/auth";

const CCFNotification = () => {
  const { authenticated } = Auth();
  const [userData, setUserData] = useState([]);
  useEffect(() => {
    getNotificatinCCFList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  const getNotificatinCCFList = async () => {
    if (authenticated) {
      setUserData([]);

      await apiCallSPGet(
        `Notification/CCF?userId=${authenticated.userId}`
      ).then((res) => {
        if (res.success) setUserData(res.data);
      });
    }
  };
  const data = [
    {
      color: "success",
      header: userData?.ccfBankGuaranteePayment,
      text: "Bank Guarantee Payment",
      onClick: "/bankguaranteelist",
      footer: "",
    },
    {
      color: "danger",
      header: userData?.ccfPendingAgreementExtend,
      text: "Pending Agreement Extend",
      onClick: "/PendingAgreementextendListCFO",
      footer: "",
    },
    {
      color: "info",
      header: userData?.ccfChequePaymentList,
      text: "Cheque Payment",
      onClick: "/emdbgpaymentList",
      footer: "",
    },
    {
      color: "warning",
      header: userData?.ccfLotTransfer,
      text: "Lot Transfer Approval",
      onClick: "/transferlotapprovals/1",
      footer: "",
    },
    // {
    //   color: "info",
    //   header: userData?.ccfLotTransfer,
    //   text: "Lot - Transfer ",
    //   onClick: "/transferlotapprovals",
    //   footer: "",
    // },
    {
      color: "primary",
      header: userData?.ccfLotTransferHOApproval,
      text: "Lot - Transfer – HO Approval",
      onClick: "/transferlotapprovals/2",
      footer: "",
    },
  ];

  const dataLotDetails = [
    {
      color: "secondary",
      header: userData?.ccfAgreementLatterSigned,
      text: "Agreement Letter Signed",
      onClick: "/lotlist/1",
      footer: "",
    },
  ];

  return (
    <CRow>
      <CCol xs="12">
        <CCard class="dashboard HO">
          <CCardHeader>
             {/* <CRow>
                          <CCol>
                            <div >
                         <br></br>
                         <marquee style={{ color: 'red', fontWeight: 'bold', fontSize: '18px', Height:'50px' }}>Important Note: Our website will undergo scheduled maintenance and will be unavailable for approximately 30 hours starting from 10th October 2025 at 11:59 PM onwards.</marquee>
                      </div> 
                          </CCol>
                        </CRow> */}
            <CRow className="pt-3 ">
              <CCol>
                {/* <h3>CCF Home</h3> */}
                <h3>Notification</h3>
              </CCol>
            </CRow>
          </CCardHeader>
          <CCardBody>
            <CRow className="pt-3 ">
              {data.map((item, index) => (
                <CustomWidgetProgress item={item} index={index} />
              ))}
            </CRow>
            <CRow className="pt-3 ">
              {dataLotDetails.map((item, index) => (
                <CustomWidgetProgress item={item} index={index} />
              ))}
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  );
};

export default CCFNotification;
